<template>
  <v-btn
    v-if="showAiAgent"
    variant="text"
    color="primary"
    icon
    @click="openAiAgent"
  >
    <v-icon>mdi-creation</v-icon>
  </v-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

export default defineComponent({
  name: 'AiAgentButton',

  computed: {
    ...mapState({
      userId: (state: any) => state.userId,
    }),
    showAiAgent (): boolean {
      // Beta feature for specific users
      return [2, 91, 92, 436, 602].includes(this.userId);
    },
  },

  methods: {
    openAiAgent () {
      this.$eventBus.$emit('open:ai-agent');
    },
  },
});
</script>
